import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { error } from '../ErrorHandling';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import { ProgramDetailResource } from '../ProgramStore/Types';
import { TPlainTextKey } from '../Translations';
import { loading, ProfessorsResource, ProfessorsState, ready, waiting } from './Types';

class ProfessorsStore {
  @observable
  state: ProfessorsState;

  constructor() {
    makeObservable(this);

    this.state = waiting();
  }

  @action
  loading = (programDetailResource: ProgramDetailResource) => {
    this.state = loading(programDetailResource);
  };

  @action
  ready = (professorsResource: ProfessorsResource) => {
    this.state = ready(professorsResource);
  };

  @computed
  get professors(): Maybe<ProfessorsResource> {
    switch (this.state.kind) {
      case 'ready':
        return just(this.state.professorsResource);
      case 'loading':
      case 'waiting':
      case 'error':
        return nothing();
    }
  }

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default ProfessorsStore;
